module.exports = __webpack_public_path__ + "img/show2_mobel.208f43db.svg";